import { get } from 'lodash';
import { mapState, mapActions } from 'vuex';
import collapsiblePanel from '@/components/collapsible-panel/collapsible-panel.vue';
import collapsiblePanelSimple from '@/components/collapsible-panel/components/collapsible-panel-simple/collapsible-panel-simple.vue';
import faqSearchInput from '@/components/support/faq-search-input/faq-search-input.vue';
import contentHeader from '@/components/generics/content-header/content-header.vue';
import scrollTo from '@/utils/scrollTo';
import supportMixin from '@/mixins/support';
import loaderMixin from '@/mixins/loader';
import staticPageHeader from '@/components/static-page-header/static-page-header.vue';
import contentLoaderMixin from '@/mixins/contentLoader';

export default {
  mixins: [
    loaderMixin,
    supportMixin,
    contentLoaderMixin,
  ],
  props: {
    title: {
      type: String,
      default: 'FAQs',
    },
    minLength: {
      type: Number,
      default: 2,
    },
    triggerNavigateToHelpAndSupport: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    collapsiblePanel,
    collapsiblePanelSimple,
    faqSearchInput,
    contentHeader,
    staticPageHeader,
  },
  data() {
    return {
      searchTerm: '',
      noResultFound: false,
      reg: [],
      expanded: false,
      accordion: null,
      accordionQA: null,
    };
  },
  metaInfo() {
    return {
      title: 'Support',
    };
  },
  // watch: {
  //   isLayoutMobile(value) {
  //     if (!value && this.triggerNavigateToHelpAndSupport) {
  //       this.$router.push({ name: 'HelpAndSupport' });
  //     }
  //   },
  // },
  computed: {
    ...mapState('about', ['faqs']),
    filteredFAQs() {
      this.expanded = false;
      if (this.$route.params.faqid === 666) {
        this.expanded = true;
        this.searchTerm = 'how do you calculate risk in multi';
      }
      const formatTitle = (title, count) => `${title} [${count}]`;
      if (this.faqs === null) {
        return [];
      }
      if (this.searchTerm === '') {
        this.noResultFound = this.faqs.length === 0;
        // just mapping category names to add [items.count] to name
        return this.faqs.map(category => ({
          name: formatTitle(category.name, category.faqs.length),
          faqs: category.faqs,
          id: category.id,
        }));
      }
      const reg = this.getRegexp(this.searchTerm);
      // reducing categories depending on filtered QA in them
      const newCategories = this.faqs.reduce((previouse, category) => {
        const filteredQA = category.faqs.filter(qa =>
          reg.test(qa.title) || reg.test(qa.description_text));
        if (filteredQA.length > 0) {
          previouse.push({
            name: formatTitle(category.name, filteredQA.length),
            faqs: filteredQA,
            id: category.id,
          });
        }
        return previouse;
      }, []);
      this.noResultFound = newCategories.length === 0;
      return newCategories;
    },
    isEmpty() {
      return this.noResultFound;
    },
  },
  methods: {
    ...mapActions('about', ['getFaqs']),
    updateSearch(term) {
      this.searchTerm = (term.length >= this.minLength) ? term.toLowerCase() : '';
    },
    initializeComponentWithSearchTerm(term) {
      this.updateSearch(term);
      this.$nextTick(() => {
        this.expanded = true;
        this.accordion = 'faq-0';
        this.accordionQA = get(this.filteredFAQs, '[0].faqs[0].id');
      });
    },
    getRegexp(term) {
      if (!this.reg[term]) {
        this.reg[term] = new RegExp(term, 'im');
      }
      return this.reg[term];
    },
    accordionOpen(e) {
      this.accordion = e;

      if (e !== null) {
        setTimeout(() => scrollTo(document.getElementById(e), 0), 50);
      }
    },
    accordionOpenQA(e) {
      this.accordionQA = e;
    },
  },
  created() {
    // if (store.state.app.layout === 'desktop' && this.triggerNavigateToHelpAndSupport) {
    //   this.$router.push({ name: 'HelpAndSupport' });
    // }
    this.loaderAdd(document.body);
    this.getFaqs()
      .then(() => {
        this.isComponentReady = true;
        this.loaderRemove(document.body);
      })
      .catch(() => this.loaderRemove(document.body));
  },
};



// WEBPACK FOOTER //
// ./src/components/support/faq/faq.js